import type { ObjectValues } from "@/src/shared/types/objectValues";

export const DS_TOOLTIP_PLACEMENTS = {
  Top: "top",
  TopStart: "top-start",
  TopEnd: "top-end",
  Bottom: "bottom",
  BottomStart: "bottom-start",
  BottomEnd: "bottom-end",
  Left: "left",
  LeftStart: "left-start",
  LeftEnd: "left-end",
  Right: "right",
  RightStart: "right-start",
  RightEnd: "right-end",
} as const;

export type DSTooltipPlacement = ObjectValues<typeof DS_TOOLTIP_PLACEMENTS>;

export interface DSTooltipOptions {
  text: string;
  title?: string;
  kbd?: string;
  kbdMac?: string;
  placement: DSTooltipPlacement;
}

export interface DSTooltipDirectiveOptions {
  text?: string | null;
  title?: string | null;
  kbd?: string | null;
  kbdMac?: string | null;
  placement?: string | null;
  disabled?: boolean;
}

export type DSTooltipBindingValue = string | DSTooltipDirectiveOptions | false | null | undefined;
